import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import ClientAddPopupComponent from '@app/components/clients/add-popup/client-add-popup.component';
import SidebarService from '@app/services/sidebar.service';
import AppGuidelinesModule from '@app/shared/common/app-guidelines.module';
import { IButtonDropdownItem } from '@app/shared/common/button-dropdown/ButtonDropdownItem';
import { IMenuItem } from '@app/shared/layout/navigation/MenuItem';
import SvgIconComponent from '@app/shared/svg-icon/svg-icon.component';
import AppComponentBase from '@shared/common/app-component-base';
import UtilsModule from '@shared/utils/utils.module';

@Component({
    selector: 'app-navigation',
    imports: [
        RouterLink,
        SvgIconComponent,
        UtilsModule,
        AppGuidelinesModule,
    ],
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.less'],
    encapsulation: ViewEncapsulation.None,
})
class NavigationComponent extends AppComponentBase implements OnInit {
    menuItems: IMenuItem[] = [
        { name: this.l('Offers'), link: '/app/offers' },
        { name: this.l('Progress'), link: '/app/progress' },
        { name: this.l('Matches'), link: '/app/matches' },
        { name: this.l('Clients'), link: '/app/clients' },
        { name: this.l('Calls'), link: '/app/calls' },
        { name: this.l('Estates'), link: '/app/estates' },
    ];

    addButtonDropdownItems: IButtonDropdownItem[] = [
        { text: this.l('Note'), icon: 'note', onClick: () => this.openAddNotePopup() },
        // It will stay hidden for now
        //{ text: this.l('Task'), icon: 'check-square', onClick: () => this.openAddTaskPopup() },
        { text: this.l('Meeting'), icon: 'calendar', onClick: () => this.openAddMeetingPopup() },
        { text: this.l('Viewing'), icon: 'location-arrow-compass', onClick: () => this.openAddViewingPopup() },
        { text: this.l('Client'), icon: 'user-circle', onClick: () => this.openAddClientPopup() },
        { text: this.l('Offer'), icon: 'home', onClick: () => this.openAddOfferPopup() },
        { text: this.l('Search'), icon: 'home', onClick: () => this.openAddSearchPopup() },
        { text: this.l('Estate'), icon: 'home' },
    ];

    notificationBell = 'notification-bell';

    constructor(
        injector: Injector,
        private router: Router,
        private dialog: MatDialog,
        private sidebarService: SidebarService,
    ) {
        super(injector);

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.updateActiveItem();
            }
        });
    }

    ngOnInit(): void {
        this.updateActiveItem();
    }

    toggleSidebar(): boolean {
        this.sidebarService.showSidebar();
        return this.sidebarService.getSidebarState().value;
    }

    private openAddNotePopup(): void {
        this.router.navigate(['/app/comments/add']);
    }

    // It will stay hidden for now
    // private openAddTaskPopup(): void {
    //     this.dialog.open(TaskAddPopupComponent);
    // }

    private openAddMeetingPopup(): void {
        this.router.navigate(['/app/meetings/add']);
    }

    private openAddViewingPopup(): void {
        this.router.navigate(['/app/viewings/add']);
    }

    private openAddClientPopup(): void {
        this.dialog.open(ClientAddPopupComponent);
    }

    private openAddOfferPopup(): void {
        this.router.navigate(['/app/offers/add']);
    }

    private openAddSearchPopup(): void {
        this.router.navigate(['/app/searches/add']);
    }

    private updateActiveItem(): void {
        const currentUrl = this.router.url;
        this.menuItems.forEach((item) => {
            item.isActive = item.link === currentUrl || '/' + item.link === currentUrl;
        });
    }
}

export default NavigationComponent;
